import { apiCall, API_CONFIG, DEFAULT_PRODUCTS_PAYLOAD } from '../config/api';

export const productAPI = {
  // Fetch products with filters
  fetchProducts: async (page = 1, search = '', filterStatus = 'all', filterCategory = 'all', filterSubCategory = 'all', limit, imageFilter = 'all', stickerFilter = 'all') => {
    const payload = {
      ...DEFAULT_PRODUCTS_PAYLOAD,
      page,
      limit: limit ? limit : 50,
      searchQuery: search.trim(),
      isAvailable: filterStatus === 'all' ? '' : filterStatus === 'instock' ? 'yes' : 'no',
      category: filterCategory !== 'all' ? filterCategory : '',
      subCategory: filterSubCategory === 'all' ? '' : filterSubCategory,
      imageFilter: imageFilter,
      stickerFilter: stickerFilter
    };

    return await apiCall(API_CONFIG.ENDPOINTS.PRODUCTS_LIST, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  // Add new product
  addProduct: async (payload) => {
    return await apiCall(API_CONFIG.ENDPOINTS.PRODUCTS_ADD, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  // Update product
  updateProduct: async (formData) => {
    return await apiCall(API_CONFIG.ENDPOINTS.PRODUCTS_UPDATE, {
      method: 'PUT',
      body: formData
    });
  },

  // Delete product
  deleteProduct: async (productId) => {
    return await apiCall(`${API_CONFIG.ENDPOINTS.PRODUCTS_DELETE}${productId}`, {
      method: 'DELETE'
    });
  }
};